module.exports = __webpack_public_path__ + "static/img/15040823001.f714a61.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/15040823001.jpg
// module id = QHUo
// module chunks = 0